import React from 'react';
import { NEU_BG, NEU_RAISED, BORDER_SUBTLE, TEXT_PRIMARY } from '../theme';

const ChartCard = ({ title, children, style = {} }) => (
  <div style={{
    background: NEU_BG,
    borderRadius: 16,
    boxShadow: NEU_RAISED,
    border: `1px solid ${BORDER_SUBTLE}`,
    padding: '20px 24px',
    ...style,
  }}>
    {title && (
      <div style={{
        fontSize: 14, fontWeight: 700, color: TEXT_PRIMARY, marginBottom: 16,
      }}>
        {title}
      </div>
    )}
    {children}
  </div>
);

export default ChartCard;
